import { List, Record } from 'immutable';

export const LocationsList = new Record({
	id: null,
	isNew: true,
	isPending: false,
	count: 0,
	items: new List(),
	created_at: new Date(),
})

export function createLocationsList(data) {
	if (data.items)
		data.items.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1)

	let items = data.items.reduce((list, province) => {
			list.push({
				id:Number(province.id),
				nombre:province.nombre
			});
			return list;
		}, []);

	return new LocationsList({
		id: data.id,
		isNew: false,
		items : new List(items) || new List(),
		count: data.count,
	});
}
